<template>
  <div class="consignSettle">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: planType === 0 }">公路</div>
      <div @click="typeFun(1)" :class="{ active: planType === 1 }">水路</div>
      <!--      <div @click='typeFun(2)' style="width: 180px"  :class='{ active: planType === 2  }'>水路（资源车）</div>-->
      <div @click="typeFun(3)" :class="{ active: planType === 3 }">公路补结算</div>
      <div @click="typeFun(4)" class="right" :class="{ active: planType === 4 }">水路补结算</div>
    </div>
    <div class="componentsContainer">
      <!-- 公路 -->
      <highWay v-if="planType === 0" ref="highWayRef" />
      <!-- 水路 -->
      <water v-else-if="planType === 1" ref="waterRef" />
      <!-- 水路（资源车） -->
      <water-resources-car v-else-if="planType === 2" ref="waterResourcesCarRef" />
      <!--公路补结算-->
      <high-way-supplementary-settlement v-if="planType === 3" />
      <!--水路补结算-->
      <water-way-supplementary-settlement v-if="planType === 4" />
    </div>
  </div>
</template>

<script>
  import highWay from '@/views/settle/supplier/components/highWay';
  import water from '@/views/settle/supplier/components/water';
  import waterResourcesCar from '@/views/settle/supplier/components/waterResourcesCar';
  import HighWaySupplementarySettlement from '@/views/settle/supplier/components/highWaySupplementarySettlement.vue';
  import WaterWaySupplementarySettlement from '@/views/settle/supplier/components/waterWaySupplementarySettlement.vue';

  export default {
    components: {
      WaterWaySupplementarySettlement,
      HighWaySupplementarySettlement,
      highWay,
      water,
      waterResourcesCar,
    },

    data() {
      return {
        planType: 0,
      };
    },
    methods: {
      typeFun(val) {
        this.planType = val;
        this.$nextTick(() => {
          // 0 公路 1 水路
          if (val === 0) {
            // 调用子组件分页查询
            setTimeout(() => {
              // this.$refs.highWayRef._supplierLinePageList(0);
            }, 100);
          } else if (val === 1) {
            // 调用子组件分页查询
            setTimeout(() => {
              //   this.$refs.waterRef._supplierLinePageList(1);
            }, 100);
          } else {
            // this.$refs.waterResourcesCarRef._supplierLinePageList(1);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .consignSettle {
    width: 100%;
    padding: 20px 15px 0 25px;
    display: flex;
    flex-direction: column;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 460px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }

    .componentsContainer {
      width: 100%;
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }
</style>
